<template>
    <BaseSection
        class="section--our-campus"
        :class="[header ? 'section--header' : '', largeHeader ? 'section--large-header' : '']"
        data-width="wide-content"
        :alignment="headerAlignmentMapped"
    >
        <template
            v-if="header"
            v-slot:title
        >
            {{ header }}
        </template>
        <template
            v-if="description"
            v-slot:description
        >
            <div v-html="description" /></template> <!-- eslint-disable-line -->
        <CampusBlocks :campus-blocks="campusBlocks" />
    </BaseSection>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
            required: true,
            default: () => { return {}; }
        }
    },
    computed: {
        header() {
            return this?.content?.header ?? '';
        },
        largeHeader() {
            return this?.content?.largeHeader ?? true;
        },
        headerAlignment() {
            return this.content.headerAlignment ?? true;
        },
        headerAlignmentMapped() {
            if (this.headerAlignment) {
                return 'center';
            }
            return 'left';
        },
        description() {
            return this?.content?.description ?? '';
        },
        campusBlocks() {
            return this?.content?.campusBlocks ?? [];
        }
    }
};
</script>
